<template>
    <div>
        <div class="container-fluid-grid" v-if="$appUtils.isDesktop()">
            <div class="row">
                <div class="col-12">
                    <table class="table table-striped table-sm">
                        <thead class="thead-dark thead-center">
                        <tr>
                            <th style="width: 100px">Data</th>
                            <th style="width: 100px">Número</th>
                            <th>Vendedor</th>
                            <th>Comprador</th>
                            <th>Produto</th>
                            <th style="width: 100px">Quantidade</th>
                            <th style="width: 100px">Preço</th>
                            <th style="width: 100px">Safra</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(p) in proposals"
                            :key="p.id">
                            <td class="ellipsis t-c">{{p.created_at | formatDate}}</td>
                            <td class="ellipsis t-c">
                                <router-link :to="`/proposals/${p.id}/edit`" class="link-theme">{{p.number}}</router-link>
                            </td>
                            <td class="ellipsis" :class="{'f-w-700': p.group_seller.id === entity.customer_group_id}">{{p.group_seller.name}}</td>
                            <td class="ellipsis" :class="{'f-w-700': p.group_buyer.id === entity.customer_group_id}">{{p.group_buyer.name}}</td>
                            <td class="ellipsis">
                                <router-link :to="`/products/${p.product.id}/edit`" class="link-theme">{{p.product.name}}</router-link>
                            </td>
                            <td class="ellipsis t-r">{{p.quantity}}</td>
                            <td class="ellipsis t-r">{{p.price | formatMoney}}</td>
                            <td class="ellipsis t-c">{{p.harvest}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div v-else class="grid-mobile"
             v-for="(p) in proposals"
             :key="p.id">
            <span class="date">{{p.created_at | formatDate}}</span>
            <span class="prop"><router-link :to="`/proposals/${p.id}/edit`" class="link-theme">{{p.number}}</router-link></span>

            <span class="seller ellipsis" :class="{'f-w-700': p.group_seller.id === entity.customer_group_id}">
                        <span class="label">Vendedor</span>
                        {{p.group_seller.name}}
                    </span>
            <span class="buyer ellipsis" :class="{'f-w-700': p.group_buyer.id === entity.customer_group_id}">
                        <span class="label">Comprador</span>
                        {{p.group_buyer.name}}
                    </span>

            <span class="prod ellipsis">
                        <span class="label">Produto</span>
                        <router-link :to="`/products/${p.product.id}/edit`" class="link-theme">{{p.product.name}}</router-link>
                    </span>
            <span class="qtd">
                        <span class="label">Quantidade</span>
                        {{p.quantity}}
                    </span>

            <span class="price">
                        <span class="label">Preço</span>
                        {{p.price | formatMoney}}
                    </span>
            <span class="harvest">
                        <span class="label">Safra</span>
                        {{p.harvest}}
                    </span>
        </div>

        <div ref="intersect" class="t-c refresh-container">
            <svg-icon icon="sync" svg-class="refresh load-more-crud" v-if="searching"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ProposalsTab",
        props: {
            entity: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                proposals: [],
                observerPagination: null,
                currentPage: 1,
                searching: false,
                isEnd: false
            }
        },
        methods: {
            loadMore() {
                if (this.entity.id && !this.searching && !this.isEnd){
                    this.searching = true;
                    this.$appHttp.get(`/v1/customers/load_proposals/${this.entity.id}?page=${this.currentPage++}`)
                        .then(({data}) => {
                            this.proposals.push(...data);
                            this.isEnd = data.length === 0;
                        })
                        .catch(err => {
                            this.$appUtils.vibrate();
                            this.$snotify.error(this.$t('common.tryContactSupport', {msg: 'Ops... Aconteceu algum problema ao carregar as confirmações de negócios.'}), this.$appStorage.getUser().name);
                            console.error(err);
                        })
                        .finally(() => this.searching = false)
                }
            }
        },
        mounted() {
            this.loadMore();

            this.observerPagination = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) this.loadMore()
                })
            }, {
                root: null,
                rootMargin: '400px'
            });

            this.observerPagination.observe(this.$refs.intersect);
        },
        destroyed() {
            if (this.observerPagination) {
                this.observerPagination.disconnect();
                this.observerPagination = null;
            }
        }
    }
</script>
<style lang="scss" scoped>
    .refresh-container {
        svg {
            width: 2em;
            height: 2em;
        }
    }

    .grid-mobile {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-areas: 'date prop' 'seller buyer' 'prod qtd' 'price harvest';
        grid-template-rows: auto;
        grid-gap: 5px;
        padding: 5px;

        &:not(:first-child) {
            border-top: 1px solid #e7eaec;
        }

        font-size: .8em;

        .label {
            display: block;
            font-weight: bold;
            font-size: .8em;
        }

        .date{grid-area: date}
        .prop{
            grid-area: prop;
            text-align: right;
        }

        .seller{grid-area: seller}
        .buyer{
            grid-area: buyer;
            text-align: right;
        }

        .prod{grid-area: prod}
        .qtd{
            grid-area: qtd;
            text-align: right;
        }

        .price{grid-area: price}
        .harvest{
            grid-area: harvest;
            text-align: right;
        }
    }
</style>
